import styled from '@emotion/styled'

export const ImportedInvoiceDetailPanelWrapper = styled.div`
  height: 100%;
  overflow-y: auto;
`
